<template>
  <div class="video-analysis-box">
    <div class="video-preview">
      <div class="video-preview-img">
        <el-image style="width: 135px; height: 100%" :src="info.preview_url"> </el-image>

        <div class="video-preview-info">
          <el-tooltip effect="dark" :content="info.name" placement="top">
            <h4>{{ info.name }}</h4>
          </el-tooltip>

          <p>已选择用于爆款复刻</p>
        </div>
      </div>
      <div class="refresh">
        <span class="el-icon-refresh" @click="$emit('reselect')"></span>
      </div>
    </div>

    <el-alert class="analysis-success" show-icon :title="`爆款拆解完成！已识别${slice.length}个分镜`" type="success" :closable="false">
    </el-alert>

    <h4 class="analysis-title">拆解出的分镜：</h4>

    <div class="analysis-box">
      <div class="analysis-item" v-for="(item, index) in slice" :key="index">
        <span class="index-num">{{ index + 1 }}</span>
        <div class="info">
          <h4 class="title">{{ item.content_title }}</h4>
          <p class="strategy">策略：{{ item.content_strategy }}</p>
          <p class="break-point">爆点：{{ item.popular_point }}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue'

// eslint-disable-next-line
const props = defineProps({
  info: {
    type: Object,
    default: () => {}
  }
})

const slice = computed(() => {
  return props.info.analysisTaskResult?.taskResult?.slices || []
})
</script>

<style scoped lang="scss">
.video-analysis-box {
  padding: 15px;
  border-radius: 8px;
  border: 2px solid #8fc4ff;
  background: #eef7ff;
  .video-preview {
    display: flex;
    align-items: center;

    .video-preview-img {
      display: flex;
      align-items: center;
      flex: 1;

      .el-image {
        border-radius: 4px;
      }

      .video-preview-info {
        margin-left: 10px;
        h4 {
          font-size: 18px;
          width: 260px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
        p {
          font-size: 13px;
          line-height: 15px;
        }
      }
    }

    .refresh {
      width: 50px;
      text-align: center;
      font-size: 22px;
    }
  }

  .analysis-success {
    margin-top: 10px;
    border: 2px solid rgb(183, 243, 204);
  }

  // .analysis-title {
  //   margin-top: 10px;
  // }

  .analysis-box {
    .analysis-item {
      display: flex;
      background: #fff;
      border-radius: 8px;
      padding: 12px;
      margin-bottom: 15px;

      .index-num {
        background: #dbeaff;
        color: #165dfb;
        border-radius: 100px;
        min-width: 28px;
        height: 28px;
        line-height: 28px;
        text-align: center;
        font-weight: 700;
        margin-right: 10px;
      }
      .info {
        h4,
        p {
          line-height: 14px;
        }

        h4 {
          margin-bottom: 10px;
        }
        p {
          font-size: 12px;
          &.strategy {
            margin-bottom: 10px;
          }
        }
      }
    }
  }
}
</style>
